/* WILINWORLD editorial theme JS (Windsor-style layout). Draft only. */
(function(){
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  function ready(fn){ document.readyState==='loading'?document.addEventListener('DOMContentLoaded',fn):fn(); }
  ready(function(){
    /* Announce rotator */
    document.querySelectorAll('[data-wds-announce]').forEach(function(bar){
      var msgEl = bar.querySelector('[data-wds-msg]');
      var raw = (bar.querySelector('[data-wds-msgs]')||{}).textContent||'';
      var msgs = raw.split('|').map(function(s){return s.trim();}).filter(Boolean);
      if(msgs.length<2) return;
      var i=0;
      function show(n){ i=(n+msgs.length)%msgs.length; msgEl.style.opacity=0; setTimeout(function(){ msgEl.textContent=msgs[i]; msgEl.style.opacity=1; },180); }
      msgEl.style.transition='opacity .2s';
      var t=setInterval(function(){show(i+1);},4200);
      var nx=bar.querySelector('[data-wds-next]'), pv=bar.querySelector('[data-wds-prev]');
      if(nx) nx.onclick=function(){show(i+1);clearInterval(t);t=setInterval(function(){show(i+1);},4200);};
      if(pv) pv.onclick=function(){show(i-1);clearInterval(t);t=setInterval(function(){show(i+1);},4200);};
    });

    /* Ticker: duplicate for seamless -50% loop */
    if(!reduce) document.querySelectorAll('[data-wds-ticker]').forEach(function(tr){ tr.innerHTML += tr.innerHTML; });

    /* Sticky promo tab */
    if(!sessionStorage.getItem('wds_promo_hidden')){
      var tab=document.createElement('div'); tab.className='wds-promo-tab wds-scope';
      tab.innerHTML='<span>Save 15% &mdash; first order</span><button aria-label="Dismiss">&times;</button>';
      document.body.appendChild(tab);
      tab.querySelector('button').onclick=function(){ tab.classList.add('is-hidden'); try{sessionStorage.setItem('wds_promo_hidden','1');}catch(e){} };
    }

    /* Reveal on scroll */
    var els=document.querySelectorAll('.wds-reveal');
    if('IntersectionObserver' in window && !reduce){
      var io=new IntersectionObserver(function(en){ en.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } }); },{threshold:.12,rootMargin:'0px 0px -8% 0px'});
      els.forEach(function(el){ io.observe(el); });
    } else { els.forEach(function(el){ el.classList.add('in'); }); }
  });
})();
